import Vue from 'vue';
import transHelpers from '../util/transHelpers';

const mixin = {
	computed: {
		dropdownTrans() {
			return {
				all_options:        this.$I18n ? this.$I18n.trans('commons.all') : 'All',
				multiple_selection: this.$I18n ? this.$I18n.trans('one.filtered') : 'Filtered',
				no_selection:       this.$I18n ? this.$I18n.trans('one.choose_your_option') : 'No selection',
			};
		},
		allTeamsLabel() {
			return this.$I18n ? this.$I18n.trans('commons.all_types', { type: this.transChoiceUcFirst('commons.team', 2) }) : 'All teams';
		},
		actionLabel() {
			return this.$I18n ? this.$I18n.trans('one.action') : 'Action';
		},
		atheleteLabel() {
			return this.$I18n ? this.$I18n.trans_choice('one.athlete', 1) : 'Athlete';
		},
		selectAthleteLabel() {
			return this.$I18n ? this.$I18n.trans('one.select_athlete') : 'Select Athlete (optional)';
		},
		timeLabel() {
			return this.$I18n ? this.$I18n.trans('commons.time') : 'Time';
		},
		durationLabel() {
			return this.$I18n ? this.$I18n.trans('commons.duration') : 'Duration';
		},
		deleteBtnLabel() {
			return this.$I18n ? this.transUcfirst('commons.delete') : 'Delete';
		},
		cancelBtnLabel() {
			return this.$I18n ? this.transUcfirst('commons.cancel') : 'Cancel';
		},
		tagsLabel() {
			return this.$I18n ? this.$I18n.trans_choice('one.tag', 2) : 'Tags';
		},
		noData() {
			return this.$I18n ? this.$I18n.trans_choice('commons.no_data', 2) : 'No data';
		},
		shareLabels() {
			return {
				SHARE_EVENT:       this.$I18n ? this.$I18n.trans('commons.share_event') : 'Share Event',
				SHARE_TAG:         this.$I18n ? this.$I18n.trans('commons.share_tag') : 'Share Tag',
				SHARE_CLIP:        this.$I18n ? this.$I18n.trans('commons.type_share', { type: this.$I18n.trans_choice('commons.clip', 1) }) : 'Share Clip',
				SHARE:             this.$I18n ? this.transUcfirst('commons.share') : 'Share',
				COPY_LINK:         this.$I18n ? this.$I18n.trans('commons.copy_link') : 'Copy Link',
				PREVIEW_NOT_FOUND: this.$I18n ? this.$I18n.trans('commons.preview_not_found') : 'Preview not found',
				CLIP_URL:          this.$I18n ? `${this.$I18n.trans_choice('commons.clip', 1)}-${this.$I18n.trans('commons.url')}` : 'Clip URL',
				TAG_URL:           this.transUcfirst('one.tag_url'),
			};
		},
	},
	methods: {
		trans(key, replace = {}) {
			return transHelpers.trans(key, replace);
		},
		transUcfirst(key, replace = {}) {
			return transHelpers.transUcfirst(key, replace);
		},
		transChoice(key, count = 1) {
			return transHelpers.transChoice(key, count);
		},
		transChoiceUcFirst(key, count = 1) {
			return transHelpers.transChoiceUcFirst(key, count);
		},
		transTagLabel(label, sportName, tag) {
			return transHelpers.transTagLabel(label, sportName, tag);
		},
		transSportName(sportName, ucFirst = true) {
			const transFoo = ucFirst ? transHelpers.transUcfirst : transHelpers.transUcfirst;
			return transFoo(`sports.${sportName}.name`);
		},
	},
};

const install = (instance = Vue) => {
	instance.mixin(mixin);
};

export { install, mixin };
